import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useMemo } from '@redneckz/uni-jsx/lib/hooks';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { Shimmer } from '../../ui-kit/Shimmer/Shimmer.js';
import { ProductBlock } from '../ProductBlock/ProductBlock.js';
export const AdTile = JSX((props) => {
    const { items } = (props.options?.page?.adSourceBook ?? {});
    const tileIndex = useMemo(() => randomNumber(0, items?.length), [items]);
    const content = items?.[tileIndex];
    return content ? (_jsx(ProductBlock, { suppressHydrationWarning: true, ...content, ...props })) : (_jsx(BlockWrapper, { ...props, children: _jsx(Shimmer, {}) }));
});
const randomNumber = (min = 0, max = 0) => Math.floor(Math.random() * (max - min) + min);
//# sourceMappingURL=AdTile.js.map